import React, { useEffect } from 'react';
import './escolher-icone.component.scss';
import ImageIcon from '@mui/icons-material/Image';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import { LoadingService } from '../../services/loading.service';
import { SnackService } from '../../services/snack.service';
import AttachmentModel from '../../models/attachment.model';
import { getAuthUser, getSiteID } from '../../services/auth';
import UsuarioModel from '../../models/usuario.model';
import { CloudUpload } from '@mui/icons-material';
import { ItensGaleria } from '../../models/galeria.model';
import IconesSVGComponent from '../svg-icon/svg-icon.component';
import { getIconsMuiMaterial } from '../../services/get-icons-mui';
import PaginacaoIconesComponent from '../paginacao-icones/paginacao-icones.component';

type EscolherIconeProps = {
  setVal: (val: string) => void;
  icone?: string;
}

function EscolherIconeComponent(props: EscolherIconeProps) {

  const [listIcones, setListIcones] = React.useState<Array<string>>([]);
  const [abreModal, setAbreModal] = React.useState<boolean>(false);
  const [iconeSelecionado, setIconeSelecionado] = React.useState<string | undefined>(props.icone);

  useEffect(() => {
    setTimeout(() => {
      //uploadFile();
    }, 200);
  }, [iconeSelecionado]);

  const ListIcones = () => {
    setListIcones(getIconsMuiMaterial());
    setAbreModal(true);
  }

  return (
    <section className='escolher-icone'>
      <div className="box-img-selecionada">
        {
          iconeSelecionado &&
          <IconesSVGComponent className='selecionado' iconName={iconeSelecionado}></IconesSVGComponent>
        }
        <Button className='bt' onClick={ListIcones}>
          Escolher ícone
        </Button>
      </div>
      <div className={"modal-icones ativo-" + abreModal}>
        <div className="box">
          <div className="scrolly">
            {
              // listIcones ? listIcones.map((item, indexIcone) => (
              //   <IconesSVGComponent key={indexIcone} iconName={item}></IconesSVGComponent>
              // )) : <span>Nenhum item encontrado.</span>
            }

            <PaginacaoIconesComponent setVal={(val) => {
              setIconeSelecionado(val);
              props.setVal(val);
              setAbreModal(false);
            }} originalData={listIcones} />
          </div>

          <Button className='fechar' onClick={() => setAbreModal(false)}><CloseIcon /></Button>
        </div>
      </div>
    </section>
  );
}

export default EscolherIconeComponent;
